/**
 * Values (except `''`) must match glubes-api `AuthorsHandler` `AUTHOR_TITLE_ALLOWED`.
 */
export const AUTHOR_TITLE_OPTIONS = [
  { value: '', label: 'Байхгүй' },
  { value: 'dr', label: 'Доктор (Dr.)' },
  { value: 'prof', label: 'Профессор (Prof.)' },
  { value: 'mr', label: 'Ноён (Mr.)' },
  { value: 'mrs', label: 'Хатагтай (Mrs.)' },
  { value: 'ms', label: 'Хатагтай (Ms.)' },
] as const;

export type AuthorTitleValue = (typeof AUTHOR_TITLE_OPTIONS)[number]['value'];

const allowed = new Set<string>(AUTHOR_TITLE_OPTIONS.map((o) => o.value));

export function isAuthorTitleValue(value: string): value is AuthorTitleValue {
  return allowed.has(value);
}

/** Short label for tables (no parenthetical). */
export function authorTitleShortLabel(value: string | undefined): string {
  const v = (value ?? '').trim();
  if (!v) return '';
  const row = AUTHOR_TITLE_OPTIONS.find((o) => o.value === v);
  if (!row || row.value === '') return '';
  return row.label.split(' (')[0]?.trim() ?? row.label;
}
